import { type SupplierListItem } from '@choco-admin/types';

import { type GetSupplierDetailsDataQuery } from '../../../generated';
import { isValidSortCartBy } from '../utils/typeGuards';

export const mapSupplierToProfileItem = (
  supplier: NonNullable<GetSupplierDetailsDataQuery['supplier']>
): SupplierListItem => {
  return {
    id: supplier.id,
    name: supplier.name || null,
    description: supplier.description || null,
    primaryAssortment: supplier.primaryAssortment || null,
    secondaryAssortments: supplier.secondaryAssortments || null,
    deliveryCosts: supplier.deliveryCosts || null,
    minOrder: supplier.minOrder || null,
    referenceId: supplier.referenceId || null,
    accessPackage: supplier.accessPackage || null,
    isIntegrated: supplier.isIntegrated || null,
    locale: supplier.locale || null,
    contactEmails: supplier.contactEmails || null,
    botUserId: supplier.botUser?.id || null,
    botUser: supplier.botUser
      ? {
          profileImage: supplier.botUser.profileImage
            ? {
                mediumSquare:
                  supplier.botUser.profileImage.mediumSquare || null,
              }
            : null,
        }
      : null,
    allowCustomProducts: supplier.allowCustomProducts || null,
    customerNumberMandatory: supplier.customerNumberMandatory || null,
    deliveryDateMandatory: supplier.deliveryDateMandatory || null,
    allowBuyerComment: supplier.allowBuyerComment || null,
    hasEnabledFractionalUnits: supplier.hasEnabledFractionalUnits || null,
    allowOnlyOneActiveVariant: supplier.allowOnlyOneActiveVariant || null,
    sortCartBy: isValidSortCartBy(supplier.sortCartBy)
      ? supplier.sortCartBy
      : null,
    // Catalog settings
    noDefaultCatalog: supplier.noDefaultCatalog || false,
    defaultSubCatalog: supplier.defaultSubCatalog || null,
    priceSetting: supplier.priceSetting
      ? {
          displayInMarketplace: supplier.priceSetting.displayInMarketplace,
          displayToCustomers: supplier.priceSetting.displayToCustomers,
        }
      : null,
    hideMyPrice: supplier.hideMyPrice || false,
  };
};
